import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrimPipe } from './trim.pipe';

@NgModule({
  declarations: [TrimPipe],
  imports: [CommonModule],
  exports: [TrimPipe],
  providers: [TrimPipe]
})
export class TrimModule { }
